export function errorMessage(ex: any): string {
    return ex?.response?.message ?? ex?.error_description ?? ex?.message ?? 'Something went wrong. Please try again.';
}
